import { apiFetch } from '../../../shared/services/apiClient';
import { ProductoDetallePublico } from '../types';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

async function fetchDetalle(url: string): Promise<ProductoDetallePublico> {
  const resp = await apiFetch(url);
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({ error: { message: 'Error desconocido' } }));
    throw new Error(err?.error?.message ?? `Error ${resp.status} al obtener detalle del producto`);
  }
  const json = await resp.json();
  return json.data as ProductoDetallePublico;
}

// Detalle por id canónico (vía histórica, SPEC-048).
export async function getProductoDetalle(id: number): Promise<ProductoDetallePublico> {
  return fetchDetalle(`${API_URL}/catalogo/publico/productos/${id}`);
}

// Detalle por proveedor_producto_id — el catálogo se lista en modo proveedor y muchos
// productos no tienen canónico; esta vía garantiza descripción/medidas/marcación.
export async function getProductoDetallePorProveedorProducto(
  id: number,
): Promise<ProductoDetallePublico> {
  return fetchDetalle(`${API_URL}/catalogo/publico/proveedor-productos/${id}`);
}
